




















import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from '@/components/commons/Button.vue';

@Component({
  components: {Button},
})
export default class ConfirmDialog extends Vue {
  @Prop({required: true})
  title: string;

  @Prop({required: true})
  content: string;
  @Prop({required: true})
  opened: boolean;

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
  }

  confirm(): void {
    this.$emit('confirm');
  }

}
